import { utils } from "@/store/helpers"
import SettingsService from "@/services/settings.service"
const initialState = {
  modules_settings: [],
  forecasting_primary_measurement: "ARR",
  swot_objects_key_metrics: {},
  objects_primary_metric: {},
  email_signature_rs: {},
  forecasting_objects_renewal_base_metrics: {},
  forecasting_objects_renewal_date_metrics: {}
}

export const settings = {
  namespaced: true,
  state: initialState,
  actions: {
    async getModulesSettings({ commit }) {
      return SettingsService.getModulesSettings().then(
        (response) => {
          commit("setModulesSettings", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    refreshModulesSettings: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({ commit }) {
        return SettingsService.getModulesSettings().then(
          (response) => {
            commit("setModulesSettings", response.data)
            return Promise.resolve(response.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },

    async updateModuleSettings({ commit, state }, { data: data, id: id }) {
      return SettingsService.updateModuleSettings(id, data).then(
        (response) => {
          commit("updateModuleSettings", response.data)
          commit("setModulesSettings", state.modules_settings)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    getSettingInfo({ state }, { reference_code: reference_code }) {
      return utils.find(state.modules_settings, { reference_code: reference_code })
    },
    /*
      Settings Reference codes are
      - renewal_base_metric
      - renewal_date_metric
      - growth_matrix_key_metric
      - forecasting_primary_measurement
     */

    async setSetting(
      { commit, state },
      {
        reference_code: reference_code,
        object_type: object_type,
        metric: metric,
        option: option,
        name: name,
        mapped_objects_metrics: mapped_objects_metrics,
        forecasting_mappings: forecasting_mappings,
        global_variables: global_variables
      }
    ) {
      let setting = utils.find(state.modules_settings, { reference_code: reference_code })
      let method = "patch"
      let data = {}
      if (setting.type == "object_selection") {
        if (utils.isEmpty(object_type)) {
          throw Error(`you need to specify which object_type to set setting of type ${setting.type}`)
        }
        data["selected_object"] = object_type
      } else if (setting.type == "metric_selection") {
        if (utils.isEmpty(metric)) {
          throw Error(`you need to specify which metric to set setting of type ${setting.type}`)
        }
        data["selected_metric"] = metric
      } else if (setting.type == "option_selection") {
        if (utils.isEmpty(option) || !utils.find(setting.available_options, { value: option })) {
          throw Error(`none valid option for setting of type ${setting.type}`)
        }
        data["selected_option"] = option
      } else if (setting.type == "multiple_object_metric_mappings") {
        if ((utils.isEmpty(object_type) || utils.isEmpty(metric)) && mapped_objects_metrics == null) {
          throw Error(`you need to specify which object_type and metric to set setting of type ${setting.type}`)
        }
        if (mapped_objects_metrics != null) {
          setting["mapped_objects_metrics"] = mapped_objects_metrics
          data = setting
          method = "put"
        } else {
          if (utils.find(setting.mapped_objects_metrics, { object_type: object_type })) {
            data["mapped_objects_metrics"] = utils.replaceItem(
              setting.mapped_objects_metrics,
              { object_type: object_type, metric: metric, name: name },
              "object_type"
            )
          } else {
            if (!Array.isArray(setting.mapped_objects_metrics)) {
              setting.mapped_objects_metrics = []
            }
            setting.mapped_objects_metrics.push({ object_type: object_type, metric: metric, name: name })
            data["mapped_objects_metrics"] = setting.mapped_objects_metrics
          }
        }
      } else if (setting.type == "forecasting_mappings") {
        if (forecasting_mappings == null) {
          throw Error(`you need to specify which object_type and metric to set setting of type ${setting.type}`)
        }
        setting["forecasting_mappings"] = forecasting_mappings
        data = setting
      } else if (setting.type == "global_variables") {
        if (global_variables == null) {
          throw Error(`you need to specify which object_type and metric to set setting of type ${setting.type}`)
        }
        setting["global_variables"] = global_variables
        data = setting
      }

      if (setting.type == "forecasting_mappings") {
        let f_data = utils.find(forecasting_mappings, { target: true })
        if (!f_data?.id) {
          return SettingsService.createForecastingMapping(f_data).then(
            (response) => {
              commit("updateModuleSettings", response.data)

              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
        } else {
          return SettingsService.updateForecastingMapping(f_data.id, f_data, method).then(
            (response) => {
              commit("updateModuleSettings", response.data)

              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
        }
      } else {
        return SettingsService.updateModuleSettings(setting.id, data, method).then(
          (response) => {
            commit("updateModuleSettings", response.data)

            return Promise.resolve(response.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },
    deleteForecasting({ commit }, id) {
      return SettingsService.deleteForecastingMapping(id).then(
        (response) => {
          commit("updateModuleSettings", response.data)
          commit("data/deleteUserForecast", id, { root: true })
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    resetForecasting({ _ }, id) {
      return SettingsService.resetForecastingMapping(id).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    resyncForecasting({ _ }, id) {
      return SettingsService.resyncForecastingMapping(id).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    takeSnapshotForecasting({ _ }, id) {
      return SettingsService.snapshotForecastingMapping(id).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async setForecastingObjectRenewalBaseMetric({ commit, state }, { object_type: object_type, metric: metric, name: name }) {
      let settings = utils.find(state.modules_settings, { reference_code: "renewal_base_metric" })
      let data = {}
      if (utils.find(settings.mapped_objects_metrics, { object_type: object_type })) {
        data["mapped_objects_metrics"] = utils.replaceItem(
          settings.mapped_objects_metrics,
          { object_type: object_type, metric: metric, name: name },
          "object_type"
        )
      } else {
        if (!Array.isArray(settings.mapped_objects_metrics)) {
          settings.mapped_objects_metrics = []
        }
        settings.mapped_objects_metrics.push({ object_type: object_type, metric: metric, name: name })
        data["mapped_objects_metrics"] = settings.mapped_objects_metrics
      }
      return SettingsService.updateModuleSettings(settings.id, data).then(
        (response) => {
          commit("updateModuleSettings", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async setForecastingObjectRenewalDateMetric({ commit, state }, { object_type: object_type, metric: metric, name: name }) {
      let settings = utils.find(state.modules_settings, { reference_code: "renewal_date_metric" })
      let data = {}
      if (utils.find(settings.mapped_objects_metrics, { object_type: object_type })) {
        data["mapped_objects_metrics"] = utils.replaceItem(
          settings.mapped_objects_metrics,
          { object_type: object_type, metric: metric, name: name },
          "object_type"
        )
      } else {
        if (!Array.isArray(settings.mapped_objects_metrics)) {
          settings.mapped_objects_metrics = []
        }
        settings.mapped_objects_metrics.push({ object_type: object_type, metric: metric, name: name })
        data["mapped_objects_metrics"] = settings.mapped_objects_metrics
      }
      return SettingsService.updateModuleSettings(settings.id, data).then(
        (response) => {
          commit("updateModuleSettings", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async setSwotObjectKeyMetic({ commit, state }, { object_type: object_type, metric: metric, name: name }) {
      let settings = utils.find(state.modules_settings, { reference_code: "growth_matrix_key_metric" })
      let data = {}

      if (utils.find(settings.mapped_objects_metrics, { object_type: object_type })) {
        data["mapped_objects_metrics"] = utils.replaceItem(
          settings.mapped_objects_metrics,
          { object_type: object_type, metric: metric, name: name },
          "object_type"
        )
      } else {
        if (!Array.isArray(settings.mapped_objects_metrics)) {
          settings.mapped_objects_metrics = []
        }
        settings.mapped_objects_metrics.push({ object_type: object_type, metric: metric, name: name })
        data["mapped_objects_metrics"] = settings.mapped_objects_metrics
      }

      return SettingsService.updateModuleSettings(settings.id, data).then(
        (response) => {
          commit("updateModuleSettings", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    //Metric Colors
    async getMetricsColors({ commit }) {
      return SettingsService.getMetricColors().then(
        (response) => {
          commit("setMetricsColors", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async updateMetricColors({ commit }, { data: data, id: id }) {
      return SettingsService.updateMetricColors(id, data).then(
        (response) => {
          commit("updateMetricColors", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async addMetricColors({ commit }, data) {
      return SettingsService.addMetricColors(data).then(
        (response) => {
          commit("addMetricColors", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    }
  },

  mutations: {
    stateReset(state) {
      Object.assign(state, initialState)
    },
    setModulesSettings(state, settings) {
      state.swot_objects_key_metrics = {}
      state.objects_primary_metric = {}
      state.forecasting_objects_renewal_base_metrics = {}
      state.forecasting_objects_renewal_date_metrics = {}
      state.modules_settings = settings
      state.forecasting_primary_measurement = utils.find(state.modules_settings, {
        reference_code: "forecasting_primary_measurement"
      })?.selected_option
      let forecasting_objects_renewal_base_metrics = utils.find(state.modules_settings, { reference_code: "renewal_base_metric" })
      if (forecasting_objects_renewal_base_metrics?.mapped_objects_metrics?.length > 0) {
        forecasting_objects_renewal_base_metrics.mapped_objects_metrics.forEach((mapping) => {
          state.forecasting_objects_renewal_base_metrics[mapping.object_type] = mapping.metric
        })
      }
      let forecasting_objects_renewal_date_metrics = utils.find(state.modules_settings, { reference_code: "renewal_date_metric" })
      if (forecasting_objects_renewal_date_metrics?.mapped_objects_metrics?.length > 0) {
        forecasting_objects_renewal_date_metrics.mapped_objects_metrics.forEach((mapping) => {
          state.forecasting_objects_renewal_date_metrics[mapping.object_type] = mapping.metric
        })
      }
      let swot_objects_key_metrics = utils.find(state.modules_settings, { reference_code: "growth_matrix_key_metric" })
      if (swot_objects_key_metrics?.mapped_objects_metrics?.length > 0) {
        swot_objects_key_metrics.mapped_objects_metrics.forEach((mapping) => {
          state.swot_objects_key_metrics[mapping.object_type] = mapping.metric
        })
      }
    },
    updateModuleSettings(state, new_settings) {
      state.modules_settings = utils.replaceItem(state.modules_settings, new_settings)
    },
    setSetting(
      state,
      {
        reference_code: reference_code,
        object_type: object_type,
        metric: metric,
        option: option,
        name: name,
        mapped_objects_metrics: mapped_objects_metrics,
        forecasting_mappings: forecasting_mappings
      }
    ) {
      let setting = utils.find(state.modules_settings, { reference_code: reference_code })
      let data = {}
      if (setting.type == "object_selection") {
        if (utils.isEmpty(object_type)) {
          throw Error(`you need to specify which object_type to set setting of type ${setting.type}`)
        }
        data["selected_object"] = object_type
      } else if (setting.type == "metric_selection") {
        if (utils.isEmpty(metric)) {
          throw Error(`you need to specify which metric to set setting of type ${setting.type}`)
        }
        data["selected_metric"] = metric
      } else if (setting.type == "option_selection") {
        if (utils.isEmpty(option) || !utils.find(setting.available_options, { value: option })) {
          throw Error(`none valid option for setting of type ${setting.type}`)
        }
        data["selected_option"] = option
      } else if (setting.type == "multiple_object_metric_mappings") {
        if ((utils.isEmpty(object_type) || utils.isEmpty(metric)) && mapped_objects_metrics == null) {
          throw Error(`you need to specify which object_type and metric to set setting of type ${setting.type}`)
        }
        if (mapped_objects_metrics != null) {
          setting["mapped_objects_metrics"] = mapped_objects_metrics
          data = setting
        } else {
          if (utils.find(setting.mapped_objects_metrics, { object_type: object_type })) {
            data["mapped_objects_metrics"] = utils.replaceItem(
              setting.mapped_objects_metrics,
              { object_type: object_type, metric: metric, name: name },
              "object_type"
            )
          } else {
            if (!Array.isArray(setting.mapped_objects_metrics)) {
              setting.mapped_objects_metrics = []
            }
            setting.mapped_objects_metrics.push({ object_type: object_type, metric: metric, name: name })
            data["mapped_objects_metrics"] = setting.mapped_objects_metrics
          }
        }
      } else if (setting.type == "forecasting_mappings") {
        if (forecasting_mappings == null) {
          throw Error(`you need to specify which object_type and metric to set setting of type ${setting.type}`)
        }
        if (forecasting_mappings != null) {
          setting["forecasting_mappings"] = forecasting_mappings
          data = setting
        }
      }

      state.modules_settings = utils.replaceItem(state.modules_settings, setting)
    }
  }
}
